export interface Project {
  id: string
  title: string
  category: 'Web Design' | 'Mobile App' | 'E-commerce'
  image: string
  description: string
  tags: string[]
}

export const projects: Project[] = [
  {
    id: '1',
    title: 'FinTech Dashboard',
    category: 'Web Design',
    image:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1000',
    description:
      'A comprehensive financial analytics platform for modern banking.',
    tags: ['React', 'TypeScript', 'D3.js'],
  },
  {
    id: '2',
    title: 'HealthTrack Mobile',
    category: 'Mobile App',
    image:
      'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&q=80&w=1000',
    description: 'Patient monitoring and appointment scheduling application.',
    tags: ['React Native', 'Node.js', 'HealthKit'],
  },
  {
    id: '3',
    title: 'Luxe Fashion Store',
    category: 'E-commerce',
    image:
      'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=1000',
    description: 'High-end fashion e-commerce experience with AR try-on.',
    tags: ['Next.js', 'Shopify', 'WebGL'],
  },
  {
    id: '4',
    title: 'Real Estate Portal',
    category: 'Web Design',
    image:
      'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80&w=1000',
    description:
      'Property listing platform with virtual tours and map integration.',
    tags: ['Vue.js', 'Mapbox', 'Firebase'],
  },
  {
    id: '5',
    title: 'FoodDelivery Pro',
    category: 'Mobile App',
    image:
      'https://images.unsplash.com/photo-1526367790999-0150786686a2?auto=format&fit=crop&q=80&w=1000',
    description: 'Hyper-local food delivery network with real-time tracking.',
    tags: ['Flutter', 'Google Maps API', 'Stripe'],
  },
  {
    id: '6',
    title: 'EduLearn Platform',
    category: 'Web Design',
    image:
      'https://images.unsplash.com/photo-1501504905252-473c47e087f8?auto=format&fit=crop&q=80&w=1000',
    description: 'Interactive learning management system for universities.',
    tags: ['React', 'Python', 'AWS'],
  },
]
